import React, { useState, useEffect } from "react";
import "../Pages/CSS/BlogPage.css";

const BlogPage = () => {
  // Sample blog data (replace with API data if available)
  const [blogs, setBlogs] = useState([
    {
      id: 1,
      title: "Latest Summer Collection 2025",
      image: "https://pk.image1993.com/cdn/shop/files/Tashkent_1.jpg?v=1766757878",
      content:
        "Discover the new summer collection for 2025 with vibrant colors and stylish designs perfect for every occasion.",
    },
    {
      id: 2,
      title: "How to Style Your KhanCollection Outfit",
      image: "https://pk.image1993.com/cdn/shop/files/Winter_Pret_35347279-ad46-4c37-94ce-1c25629f8eb1.jpg?v=1766752867",
      content:
        "Learn tips and tricks on how to style your outfit from KhanCollection to look elegant and trendy.",
    },
    {
      id: 3,
      title: "Care Instructions for Premium Fabrics",
      image: "https://pk.image1993.com/cdn/shop/files/Reshamkari_f6cd3a61-2154-432d-9788-72444e0b7925.jpg?v=1766752922",
      content:
        "Make your clothes last longer by following our detailed care instructions for premium stitched and unstitched fabrics.",
    },
  ]);

  return (
    <div className="blog-container">
      <h2>Our Blogs</h2>
      <div className="blogs-grid">
        {blogs.map((blog) => (
          <div key={blog.id} className="blog-card">
            <img src={blog.image} alt={blog.title} className="blog-image" />
            <h3>{blog.title}</h3>
            <p>{blog.content}</p>
            <button className="read-more-btn">Read More</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
